<ng-container *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		hasRefresh="true"
		maxActionsCount="6"
		[itemsCount]="vo.list.totalItems"
		[actionsAvailable]="toggleActions"
		[actions]="panelActions"
		(search)="search($event)"
		(refresh)="refresh()">
			<div panel-info>
				<ng-container *ngIf="selectionCount">
					<span>{{ selectionCount }} &#32;</span>
					<span
						i18n="@@groupingTag.list.selectedElements">
						selected-elements</span>
				</ng-container>
			</div>
			<div panel-title class="app-panel__title">
				<mat-icon [svgIcon]="DcIcons.GroupingTag"></mat-icon>
				<span
					i18n="@@groupingTag.list.title">
					grouping-tag</span>
			</div>
			<dx-data-grid
				[elementAttr]="{ id: 'grouping-tag-list', class: 'grouping-tag-list' }"
				[dataSource]="dataSource"
				[remoteOperations]="{ paging: true, filtering: true, sorting: true }"
				[filterRow]="{ visible: true, applyFilter: 'auto' }"
				[headerFilter]="{ visible: true }"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[wordWrapEnabled]="false"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[repaintChangesOnly]="true"
				[showBorders]="false"
				[width]="'100%'"
				[noDataText]="''"
				(onCellHoverChanged)="onCellHover($event)"
				(onOptionChanged)="onGridOptionChange($event)"
				(onRowClick)="rowSelected($event)"
				(onSelectionChanged)="onSelectionChange($event)"
				(onContentReady)="onGridContentReady()">
					<dxo-selection
						mode="multiple"
						selectAllMode="page"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="true"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[filterOperations]="StringFilterOperations"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="labelTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'referencedByCount'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[filterOperations]="StringFilterOperations"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="projectCountTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'createdBy'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="createdByTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'createdOn'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"></dxi-column>
					</ng-container>

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[width]="70"
						[showInColumnChooser]="false"
						cellTemplate="actionsTemplate"></dxi-column>

				<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
					<span appEllipsisTitle
						class="label-template__label"
						id="{{ cmpId }}-{{ cell.data['label'] }}">
<!--							{{ cell.data['label'] }}-->
						<app-tag-chip
							[label]="cell.data['label']"
							[color]="cell.data['color']"
							[removable]="false"
							[variant]="'tag'"
							[collapsed]="false" (dblclick)="editGroupingTag(cell.data['id'], cell.data['label'], cell.data['color'])"></app-tag-chip>
						</span>
				</div>

					<div *dxTemplate="let cell of 'projectCountTemplate'">
						<app-overlay-badge
							*ngIf="cell.data['referencedByCount'] !== 0"
							[icon]="ComponentIcons.Project"
							[value]="cell.data['referencedByCount']"
							[active]="true"
							[isOpen]="vo.openedOverlay.groupingTagId === cell.data['id']"
							(overlayDismiss)="closePopover()"
							(click)="openPopover($event, cell.data)">
							<app-popover
								overlayContent
								label="projects"
								i18n-label="@@groupingTag.project.referrals"
								[icon]="{ iconName: ComponentIcons.Project }"
								[count]="cell.data['referencedByCount']"
								(adbPopoverClose)="closePopover()">
								<div class="project-details">
									<mat-spinner
										*ngIf="cell.data['projects'].length === 0"
										[diameter]="20"></mat-spinner>
									<ng-container *ngIf="cell.data['projects'].length !== 0">
										<ng-container *ngFor="let proj of cell.data['projects']">
											<a [href]="proj.url" target="_blank">{{ proj.label }}</a>
										</ng-container>
									</ng-container>
								</div>
							</app-popover>
						</app-overlay-badge>
					</div>

					<div *dxTemplate="let cell of 'statusTemplate'">
<!--						<app-status-badge-->
<!--							[status]="cell.data['status']"></app-status-badge>-->
					</div>

					<div *dxTemplate="let cell of 'tagsTemplate'">
<!--						<app-tag-configurator-->
<!--							*ngIf="cell.data['tags'].length !== 0"-->
<!--							displayMode="tags"-->
<!--							configMode="View"-->
<!--							[configuredTags]="cell.data['tags']"></app-tag-configurator>-->
					</div>

				<div
					*dxTemplate="let cell of 'createdByTemplate'"
					class="avatar-template">
					<app-avatar
						*ngIf="cell.data['createdByAvatar']"
						avatarSize="small"
						[avatar]="cell.data['createdByAvatar']"
						[withTooltip]="true"></app-avatar>
				</div>

					<div *dxTemplate="let cell of 'actionsTemplate'"
							 [hidden]="cell.rowIndex !== currentlyHovered">
						<div class="actions-column-template">
							<button
								mat-icon-button
								class="actions-column-template__menu-btn"
								matTooltip="update-data"
								i18n-matTooltip="@@groupingTag.list.action.updateData"
								matTooltipPosition="left"
								(click)="editGroupingTag(cell.data['id'], cell.data['label'], cell.data['color']); $event.stopPropagation();">
								<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
							</button>
							<button
								mat-icon-button
								class="actions-column-template__menu-btn"
								matTooltip="delete-data"
								i18n-matTooltip="@@groupingTag.list.action.delete"
								matTooltipPosition="left"
								(click)="deleteSelected(cell.data); $event.stopPropagation();">
								<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
							</button>
						</div>
					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Filterable columns	-->
					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-filter-row
						[visible]="vo.list.availableColumns.size !== 0"></dxo-filter-row>

					<!-- Pagination -->
					<dxo-paging [pageSize]="vo.size" [pageIndex]="vo.page"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowedPageSizes"
						[showInfo]="true"
						[showNavigationButtons]="true"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>

					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
			</dx-data-grid>
			<ng-container
				*ngIf="vo.list.elements.size === 0"
				[ngTemplateOutlet]="noData"
				[ngTemplateOutletContext]="{hasCreatePermission : vo.hasCreatePermission}"></ng-container>
	</app-panel>
</ng-container>

<ng-template #noData>
	<div class="no-data-template">
		<mat-icon
			[svgIcon]="DcIcons.GroupingTag"></mat-icon>
		<app-button
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddElement"
			i18n="@@groupingTag.action.addNew"
			(click)="triggerAddNewGroupingTag()">
			new-grouping-tag
		</app-button>
	</div>
</ng-template>

